import { useContext } from 'react';
import { TranslationContext } from "../../../contexts/TranslationContext";
import { NavPage } from "../../../services/NavService";
import { TopNav } from "../../TopNav/TopNav";


export function AdminNav(props: {
    page: NavPage
}) {
    const tc = useContext(TranslationContext);

    return (
        <TopNav header={"Admin: " + tc.translator(props.page)} />
        );
}
